import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY } from '@/state/queries/admin/use-admin-subscription-plans-query';
import { GET_SUBSCRIPTION_PLANS } from '@/state/queries/transactions/use-subscription-plans';

export function useDeleteSubscriptionPlanMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/subscription-plans/${id}`;
      return sendJSONRequest({ url, method: METHOD.DELETE, token: token ?? '' });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_SUBSCRIPTION_PLANS_QUERY_KEY] });
      await queryClient.invalidateQueries({ queryKey: [GET_SUBSCRIPTION_PLANS] });
    },
  });
}
